export default __webpack_public_path__ + "static/media/Aura-Egg__04.9f8e48d6.png";